import '../css/rotate.css';
import React from 'react';
import useIsLandscape from '../hooks/useIsLandscape';

const RotatePhone = () => {
  const isLandscape = useIsLandscape();
  return  isLandscape && (
    <div className="fixed top-0 left-0 w-screen h-screen z-[999999999999999999] bg-black bg-opacity-90 items-center justify-center flex flex-col pointer-events-auto">
      {/* <div> */}
        <div class="phone"></div>
        <p class="message text-white font-bold">
          Please rotate your phone for the best viewing experience
        </p>
      {/* </div> */}
    </div>
  );
}

export default RotatePhone;
